import React from 'react';
import { MuiButton } from '@ui/base_library';
import { ButtonProps } from '@mui/material/Button';

const TextButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <MuiButton variant="text" {...props} ref={ref}>
        {children}
      </MuiButton>
    );
  }
);

export default TextButton;
